export interface Filter {
  name: string;
}

export interface GetResourceFiltersResponse {
  serverFilters: Filter[];
  hostFilters: Filter[];
  instanceFilters: Filter[];
  databaseFilters: Filter[];
}

interface Tag {
  name: string;
  value: string;
}

interface CommonFilter {
  includeValues: string[];
  excludeValues: string[];
}

interface TagFilter {
  includeTags: Tag[];
  excludeTags: Tag[];
}

export interface GetResourceFiltersRequestBody {
  tagFilter?: TagFilter;
  hostFilter?: CommonFilter;
  instanceFilter?: CommonFilter;
  filterTypes: FilterType[];
}

export enum FilterType {
  Host = "Host",
  Instance = "Instance",
  Database = "Database",
  Server = "Server",
}
